<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Items</h3>
      </div>
    </div>
    <div style="max-height: 300px" class="table-responsive">
      <table>
        <thead>
          <tr>
            <th>Item</th>
            <th>Cod. Barra</th>
            <th>Cantidad</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in items" :key="index">
            <td>
              {{ item.descripcion_item }}
            </td>
            <td>
              {{ item.codigo_barra }}
            </td>
            <td>
              {{ item.cantidad }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="modal-buttons">
      <button
        v-if="!soloConsulta"
        @click="aceptar"
        type="button"
        class="btn-success"
      >
        <i class="fa fa-check"></i><span>Aceptar</span>
      </button>
      <button @click="cerrar" class="btn-danger btn--text">
        <i class="fa fa-times"></i><span>Cerrar</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    ruta_id: {
      type: String,
      required: false,
      default: ''
    },
    referenciaMovimiento: {
      type: String,
      required: true,
    },
    soloConsulta: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data: function () {
    return {
      items: [],
    };
  },
  methods: {
    aceptar: function () {
      swal({
        title: "¿Deseas confirmar los ítems?",
        text: "Se requiere confirmación",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sí",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.value) {
          this.$emit("aceptar", this.items);
        }
      });
    },
    cerrar: function () {
      this.$emit("cerrar");
    },
  },
  mounted: function () {
    axios
      .get(url + "/inventario/movimientos", {
        params: {
          referencia_movimiento: this.referenciaMovimiento,
          tipo: "R",
          consulta: this.soloConsulta?'S':'N',
          ruta_id: this.ruta_id
        },
      })
      .then(({ data }) => {
        for (let i = 0; i < data.length; i++) {
          this.items.push({
            item_id: data[i].item_id,
            descripcion_item: data[i].nombre,
            cantidad: data[i].cantidad,
            codigo_barra: data[i].codigo_barra,
          });
        }
        // if (this.items.length === 0) {
        //   swal(
        //     "No se ha encontrado el movimiento indicado.",
        //     "Aviso",
        //     "warning"
        //   );
        //   this.cerrar();
        // }
      })
      .catch(({ response }) => {
        const { status, data: { errors } } = response;
        if (status === 409) {
          swal(
            "El movimiento ya ha sido referenciado con anterioridad.",
            "Aviso",
            "warning"
          );
          return;
        }
        if (status === 422) 
          swal(errors.producto[0], "Aviso", "warning");
        else
          swal("Hubo un error, intente nuevamente.", "Error", "error");
        this.cerrar();
      });
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/logistica/pedidos/ItemsRecaudaciones.vue